"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var style_1 = require("../../style");
var layout_1 = require("../layout");
var Text_1 = __importDefault(require("../Text"));
var styles = {
    container: react_1.css({
        display: 'inline-block',
        borderRadius: 30,
        overflow: 'hidden',
        backgroundColor: style_1.SixsenseColor.Gray.LIGHT_4,
    }),
    progress: function (theme) {
        return react_1.css({
            // Position a full width inner div with `translateX` instead of setting the `width` because
            // transitions on `transform` properties are much more performant than on layout attributes.
            transition: 'transform 200ms ease',
            width: '100%',
            borderRadius: 30,
            height: '100%',
            backgroundColor: theme.color.PRIMARY.DEFAULT,
        });
    },
};
var coerceBetween = function (value, min, max) {
    return Math.max(Math.min(value, max), min);
};
var ProgressBar = function (_a) {
    var progress = _a.progress, _b = _a.height, height = _b === void 0 ? 10 : _b, _c = _a.width, width = _c === void 0 ? '100%' : _c, color = _a.color, _d = _a.textPosition, textPosition = _d === void 0 ? 'none' : _d;
    return (react_1.jsx(layout_1.Flex, { inline: true, direction: textPosition === 'below' ? 'column' : 'row', gap: textPosition === 'below' ? 8 : 12, alignItems: textPosition === 'below' ? 'flex-end' : 'center', style: { width: width } },
        react_1.jsx("span", { css: styles.container, style: { height: height, width: '100%' } },
            react_1.jsx("div", { css: styles.progress, style: {
                    transform: "translateX(" + (coerceBetween(progress, 0, 100) - 100) + "%)",
                    backgroundColor: color,
                } })),
        textPosition !== 'none' && (react_1.jsx(Text_1.default.Body, { color: style_1.DesignSystemThemeColor.Gray.DARK_2 }, progress + "%"))));
};
exports.default = ProgressBar;
